import classNames from 'classnames'
import { IconHP } from 'legacy/lut/assets/img/icons/IconHP'
import { sprPrivacyText } from 'legacy/shared/texts'
import React, { useContext, useEffect, useMemo } from 'react'
import sanitize from 'sanitize-html'

import { Dropdown } from 'core-components/library/dropdown'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import styles from './APLPageLayout.module.scss'

type Props = {
  children: React.ReactNode
}

const languages = [
  { id: 'en', value: 'English' },
  { id: 'de', value: 'Deutsch' },
  { id: 'es', value: 'Español' },
  { id: 'fr', value: 'Français' },
  { id: 'it', value: 'Italiano' },
  { id: 'pt', value: 'Português' },
]

export function APLAMSPageLayout({ children }: Props) {
  const { setLanguage, language, translationIsLoading } = useContext(LanguageContext)

  useEffect(() => {
    setLanguage(localStorage.getItem('apl_ams_language') || 'en')
  }, [setLanguage])

  const localeCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(languages),
      keyField: 'id',
    })
  }, [])

  const handleLanguageChange = (id: string) => {
    setLanguage(id)
    localStorage.setItem('apl_ams_language', id)
  }

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <div className={styles.logo}>
          <IconHP className={styles.logoIcon} />
        </div>
        <Dropdown
          disabled={translationIsLoading}
          source={localeCrud}
          value={language}
          caption={'value'}
          onChange={handleLanguageChange}
          label={'Language'}
        />
      </header>
      <div className={styles.divider} />
      <div className={classNames(styles.body, styles.wide)}>{children}</div>
      <div className={styles.divider} />
      <footer className={styles.header}>
        <div className={styles.logo}>
          <IconHP className={styles.logoIcon} />
        </div>
        <div
          className={styles.privacy}
          dangerouslySetInnerHTML={{ __html: sanitize(sprPrivacyText()) }}
        ></div>
      </footer>
    </div>
  )
}
